import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { PageHeader } from 'components/header/PageHeader'
import { EarnHeaderActions } from './EarnHeaderActions'

export const EarnPageHeader = () => {
  const { t } = useTranslation()

  return (
    <PageHeader
      description={
        <Box className="text-foreground-subdued text-body-regular">
          {t('earn.description')}{' '}
          <ExternalLink href={process.env.REWARDS_HOW_IT_WORKS_URL ?? ''} target="_blank">
            {t('earn.howItWorksLink')}
          </ExternalLink>
        </Box>
      }
      renderRightSection={<EarnHeaderActions />}
    />
  )
}
